let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4Of4x")).then(() => parcelRequire('jixpB'));